import React from 'react';
import BriefCreators from 'features/briefs/components/organisms/BriefCreators';
import TruncatedBriefView from 'features/briefs/components/molecules/TruncatedBriefView';
import BrandFullBriefView from 'features/briefs/components/molecules/BrandFullBriefView';
import SubmissionIndex from 'features/submissions/components/SubmissionIndex/SubmissionIndex';
import CenteredSpinner from 'features/ui/CenteredSpinner';
import { Box } from 'shared/components/display';
import FileListView, { FileAction } from 'shared/components/molecules/FileListView/FileListView';
import { Tab, TabBar } from 'shared/components/molecules/Tabs';
import { BRIEF_COPY } from 'shared/config/copy';
import { Brief } from 'shared/typings/briefs';
import { BriefStatus } from 'shared/typings/briefs/enums';

import brandBriefTabsStyles from './brandBriefTabsStyles';

interface Props {
  loading: boolean;
  brief: Brief;
  showAllBriefDetails?: boolean;
}

const BrandBriefTabs: React.FC<Props> = ({ loading, brief, showAllBriefDetails = false }) => {
  const isPending = brief?.status === BriefStatus.PENDING;
  const isDraft = brief?.status === BriefStatus.DRAFT;

  if (loading || !brief) {
    return <CenteredSpinner />;
  }

  return (
    <Box css={brandBriefTabsStyles}>
      <TabBar className="brief-tabs">
        <Tab title={BRIEF_COPY.TAB_TITLE_BRIEF}>
          {showAllBriefDetails ? (
            <BrandFullBriefView brief={brief} loading={loading} />
          ) : (
            <TruncatedBriefView brief={brief} loading={loading} />
          )}
        </Tab>
        <Tab title={BRIEF_COPY.TAB_TITLE_BRIEF_ASSETS} hidden={!brief.brandAssets.length}>
          <Box className="brief-tabs__assets-wrapper">
            <FileListView files={brief.brandAssets} action={FileAction.NONE} showFilePreview />
          </Box>
        </Tab>
        <Tab title={BRIEF_COPY.TAB_TITLE_CREATORS} hidden={isPending || isDraft} dataCy="brand-brief-tabs__creators">
          <BriefCreators currentBrief={brief} />
        </Tab>
        <Tab
          title={BRIEF_COPY.TAB_TITLE_SUBMISSIONS}
          hidden={isPending || isDraft}
          dataCy="brand-brief-tabs__submissions"
        >
          <SubmissionIndex currentBrief={brief} />
        </Tab>
      </TabBar>
    </Box>
  );
};

export default BrandBriefTabs;
